<dx-tab-panel [(selectedIndex)]="currentIndex">
  <dxi-item title="A la prestation">
    <yo-facturation-client-parametrage></yo-facturation-client-parametrage>
  </dxi-item>
  <dxi-item title="A la famille">
    <yo-facturation-client-famille-facturation-parametrage></yo-facturation-client-famille-facturation-parametrage>
  </dxi-item>
  <dxi-item title="Au produit complémentaire">
    <yo-facturation-produit-complementaire-parametrage></yo-facturation-produit-complementaire-parametrage>
  </dxi-item>
</dx-tab-panel>
